<section class="section " id="contact">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-2">
                <h1 class="section-title text-center">Contáctanos</h1>
                <div class="section-title-border margin-t-20"></div>
                <!-- <p class="section-subtitle text-muted text-center font-secondary padding-t-30">We thrive when coming up with innovative ideas but also understand that a smart concept should be supported with measurable results.</p> -->
            </div>
        </div>
        <div class="row">
            <div class="row row-cols-1 row-cols-md-2">
                <div class="col mb-4">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Bogotá</h5>
                            <p class="card-text">
                                Av. Calle 26 # 59-41 Piso 6<br> Teléfono: +57 1 606-7575<br> Fax: +57 1 487-6686<br> Ana María Gómez<br> Vicepresidenta Sucursal <br>AnaMaria.Gomez@WillisTowersWatson.com
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col mb-4">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Medellín</h5>
                            <p class="card-text">Carrera 48 # 20-114 Torre 3 Of. 648<br> Teléfono: +57 4 511-3344<br> Fax: +57 4 251-3030<br> Juan Carlos Giraldo<br> Vicepresidente Sucursal<br> JuanCarlos.Giraldo@willistowerswatson.com
                                <br>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col mb-4">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Cali</h5>
                            <p class="card-text">
                                Calle 10 Oeste # 2-50 Santa Rita<br> Teléfono: +57 2 893-0893<br> Fax: +57 2 892-6054<br> Juan Sebastián Wartenberg<br> Vicepresidente Sucursal<br> juan.wartenberg@willistowerswatson.com
                                <br>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col mb-4">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Barranquilla</h5>
                            <p class="card-text">
                                Calle 82 # 55-21<br> Teléfono: +57 5 373-6824<br> Fax: +57 5 373-6825<br> Alberto Vargas<br> Gerente Sucursal<br> alberto.vargas@willistowerswatson.com
                                <br>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col mb-4">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Cartagena</h5>
                            <p class="card-text">
                                Bocagrande Carrera 2 # 11<br> Teléfono: +57 5 665-7090<br> Fax: +57 5 665-7090 Ext. 5158<br> Alberto Vargas<br> Gerente Sucursal<br> alberto.vargas@willistowerswatson.com
                                <br>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col mb-4">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Santa Marta</h5>
                            <p class="card-text">
                                Carrera 1 # 10a - 12<br> Teléfono: +57 5 423-4491<br> Fax: +57 5 421-2161<br> Alberto Vargas<br> Gerente Sucursal<br> alberto.vargas@willistowerswatson.com
                                <br>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>